export default __webpack_public_path__ + "static/media/labyrinthen-isometry-desktop.421b4b6f.jpg";